import React, { Component } from 'react';
import SweetAlert from 'sweetalert-react';
import 'sweetalert/dist/sweetalert.css';

class Alert extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            message: '',
            type: 'success'
        };
    }

    open = (data) =>{
        this.setState({
            show:true,
            message:data.message,
            type: data.type
        })
    };

    render() {
        return (
            <SweetAlert
                show={this.state.show}
                title="Información"
                text={this.state.message}
                type={this.state.type}
                confirmButtonText="Aceptar"
                confirmButtonColor='#e44745'
                onConfirm={() => {
                    this.setState({ show: false });
                    // eslint-disable-next-line
                    this.props.callbackAlert;
                }}
            />
        );
    }
}
export default Alert;



// WEBPACK FOOTER //
// ./src/components/extras/Alert.js